<template>
  <div class="c-Pagination Spacing--responsive--noBottom">
    <div class="c-Pagination__content">
      <button v-on:click="decrement" class="c-Pagination__content--prev" :disabled="current_page == 1">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="46px" viewBox="0 0 20 46" enable-background="new 0 0 20 46" xml:space="preserve">
          <g id="Catégorie-bleu-vieillot---bouton-over" transform="translate(-53.000000, -2651.000000)">
              <g id="PAGINATION" transform="translate(53.000000, 2647.000000)">
                  <g id="PRÉCÉDENT" transform="translate(0.000000, 1.000000)">
                      <polygon id="Path-2" fill="#FFFFFF" points="19.866,3.143 0,25.923 20,48.857"/>
                  </g>
              </g>
          </g>
        </svg>
      </button>
      <span class="c-Pagination__content--wrapper">
        {{ page_title }}&nbsp;
        <div class="current js-pagination-current" v-bind:class="(editMode) ? 'is-edited' : ''" v-on:click="changeMode">
          <span class="js-pagination-begin">{{current_page}}</span>&nbsp;
          <input 
            class="current_input" 
            @blur="changeEditModeState" 
            v-on="handlers" 
            ref="inputpagination" 
            type="text" 
            name="pagination" 
            id="pagination" 
            :maxlength="(Math.ceil(count/limit)).toString().length" 
            :value="current_page"
          >
          <span>{{ page_suffix }}&nbsp;</span>
          <span class="js-pagination-end">{{(Math.ceil(count/limit))}}</span>
        </div>
      </span>
      <button v-on:click="increment" class="c-Pagination__content--next" :disabled="current_page == (Math.ceil(count/limit))">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="46px" viewBox="0 0 20 46" enable-background="new 0 0 20 46" xml:space="preserve">
            <g id="Catégorie-bleu-vieillot---bouton-over" transform="translate(-53.000000, -2651.000000)">
                <g id="PAGINATION" transform="translate(53.000000, 2647.000000)">
                    <g id="PRÉCÉDENT" transform="translate(0.000000, 1.000000)">
                        <polygon id="Path-2" fill="#FFFFFF" points="19.866,3.143 0,25.923 20,48.857"/>
                    </g>
                </g>
            </g>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Pagination",
  props : ['count','current_page','limit'],
  data() { 
    const self = this;
    return  {
      editMode: false,
      page: '',
      // translation
      page_title: window.Store.translate_strings.filter ? window.Store.translate_strings.filter.page_title : '',
      page_suffix: window.Store.translate_strings.filter ? window.Store.translate_strings.filter.page_suffix : '',
      // handlers
      handlers: {
        keyup: self.inputKeyup,
        keydown: self.inputKeydown
      }
  }},

  methods : {
    change: function(page) {
      this.$emit('change',page);
      this.editMode = !this.editMode;
    },
    increment : function() {
      this.$emit('increment');
    },
    decrement : function() {
      this.$emit('decrement');
    },
    changeMode: function(e) {
      if (window.Store.scrollbar.world.w > 1199) {
        const self = this;
        this.editMode = true;
  
        e.target.addEventListener(this.getTransitionEndEventName(), function _listener() {
          self.$refs.inputpagination.select();
          e.target.removeEventListener(self.getTransitionEndEventName(), _listener, true);
        }, true);
      }
    },
    inputKeyup: function(e) {
      if (isFinite(e.key) && e.key !== ' ') {
        if ((parseInt(e.target.value) > (Math.ceil(this.count/this.limit))) || parseInt(e.target.value) <= 0 ) {
          e.target.value = (Math.ceil(this.count/this.limit));
          return;
        }
        return;
      }
      
      if (isFinite(e.key) == false && e.key !== 'Backspace' && e.key !== 'Enter') {
        e.target.value = '';
        return;
      }
    },
    inputKeydown: function(e) {
      if (e.key === 'Enter') {
        if (parseInt(e.target.value) !== parseInt(this.current_page) && e.target.value !== '') {
          this.change(e.target.value);
          return;
        }

        this.editMode = !this.editMode;
        return;
      }

      if (e.code == 'Space') {
        e.target.value = (Math.ceil(this.count/this.limit));
      }
    },
    changeEditModeState: function() {
      this.editMode = false;
    },
    getTransitionEndEventName: function() {
      const transitions = {
        "transition": "transitionend",
        "OTransition": "oTransitionEnd",
        "MozTransition": "transitionend",
        "WebkitTransition": "webkitTransitionEnd"
      }

      let bodyStyle = document.body.style;
      for (let transition in transitions) {
        if (bodyStyle[transition] != undefined) {
          return transitions[transition];
        }
      }
    }
  }
}
</script>